import cn from 'classnames'
import { HTMLAttributes, memo } from 'react'
import { animated, config, useTransition } from 'react-spring'

import styles from './Overlay.module.scss'

export interface OverlayProps extends HTMLAttributes<HTMLDivElement> {
  show?: boolean
  variant?: 'dark' | 'blur'
  position?: 'absolute' | 'fixed'
  zIndex?: number
}

function Overlay({ show, zIndex, position, variant = 'dark', className, ...props }: OverlayProps) {
  const transition = useTransition(show, {
    reverse: show,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.gentle,
  })

  return transition((style, mounted) => {
    return (
      mounted && (
        <animated.div
          // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
          style={{ ...props.style, ...style, zIndex }}
          className={cn(styles.root, styles[position], styles[variant], className)}
          {...props}
        />
      )
    )
  })
}

export default memo(Overlay)
